import type { JbNewsletterRegistrationForm } from '@bjb/bjb-web-components/dist/components/jb-newsletter-registration-form/jb-newsletter-registration-form';
import { JbPopup } from '@bjb/bjb-web-components/dist/components/jb-popup/jb-popup.js';

const newsletterRegistrationStorageKey = 'bjb-fe-nl-reg';
const stickyWaitTime = 20 * 1000;

const resetFocusFly = () => {
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent('jb-focus-fly:reset', { bubbles: true, composed: true }));
  }, 150);
};

const openStickyNewsletterRegistration = (stickyNewsletterRegistrationForm: JbNewsletterRegistrationForm) => {
  try {
    if (localStorage.getItem(newsletterRegistrationStorageKey)) {
      return;
    }
  } catch (error) {}

  stickyNewsletterRegistrationForm.openSticky();
};

// 1. open popup newsletter registration form on mail icon click
document.addEventListener('jb-article-tool-bar:mail-icon-clicked', (event) => {
  const popupNewsletterRegistrationForm = document.querySelector('jb-newsletter-registration-form[type="popup"]') as JbNewsletterRegistrationForm | null;
  if (!popupNewsletterRegistrationForm) {
    return;
  }

  const originalParent = popupNewsletterRegistrationForm.parentElement;
  const originalNextSibling = popupNewsletterRegistrationForm.nextSibling;

  new JbPopup()
    .init({
      props: {
        animates: true,
        returnFocusTo: event.detail.returnFocusTo,
        ariaLabels: event.detail.ariaLabels || {
          label: popupNewsletterRegistrationForm.headline,
        },
      },
      childNodes: [popupNewsletterRegistrationForm],
    })
    .stack();

  popupNewsletterRegistrationForm.openPopup();
  resetFocusFly();

  const restoreForm = () => {
    popupNewsletterRegistrationForm.removeEventListener('jb-newsletter-registration:closed', restoreForm);
    if (originalParent) {
      originalParent.insertBefore(popupNewsletterRegistrationForm, originalNextSibling);
    }
  };
  popupNewsletterRegistrationForm.addEventListener('jb-newsletter-registration:closed', restoreForm);
});

// 2. open sticky newsletter registration form after 20 seconds
const stickyNewsletterRegistrationForm = document.querySelector('jb-newsletter-registration-form[type="sticky"]') as JbNewsletterRegistrationForm | null;

if (stickyNewsletterRegistrationForm) {
  if (stickyNewsletterRegistrationForm.forceInstantly) {
    openStickyNewsletterRegistration(stickyNewsletterRegistrationForm);
  } else {
    setTimeout(() => {
      openStickyNewsletterRegistration(stickyNewsletterRegistrationForm);
    }, stickyWaitTime);
  }
}

document.addEventListener('jb-newsletter-registration:closed', (event) => {
  const target = event.target as JbNewsletterRegistrationForm | null;
  const type = event.detail?.type || target?.type;

  if (type !== 'sticky') {
    return;
  }

  try {
    localStorage.setItem(newsletterRegistrationStorageKey, '1');
  } catch (error) {}
});
